export default "__VITE_ASSET__C5odPuDd__"